module.exports = __webpack_public_path__ + "static/keyPoints-de-41a1c6835d7c09cddb993104b95c84ed.png";